/* "Byg selv – trin for trin" (sections/routine-build.liquid): one step open at a time, a choice locks the step and moves
   on, the optional steps take up to their max, "Din rutine" shows what is chosen, and one add puts it all in the cart,
   tagged for the "Byg selv-rutine" discount. The choices survive a visit to a product page (sessionStorage). */

if (!customElements.get("routine-build")) {
  class RoutineBuild extends HTMLElement {
    connectedCallback() {
      this.copy = JSON.parse(this.dataset.copy || "{}");
      // "Køb rutinen" from Mit ECOOKING (?rutine=…&koeb=1): the routine goes in the cart once it is set up.
      const buy = window.ec.takeBuy && window.ec.takeBuy();
      this.min = Number(this.dataset.min) || 3;
      this.percent = Number(this.dataset.percent) || 0;
      this.steps = [...this.querySelectorAll("[data-build-step]")];
      this.navItems = [...this.querySelectorAll("[data-build-goto]")];
      this.done = this.querySelector("[data-build-done]");
      this.addBtn = this.querySelector("[data-build-add]");
      this.storeKey = "ecooking-build:" + location.pathname;
      // Per step: the product ids chosen, in the order chosen; "skipped" when passed over.
      this.picks = this.steps.map(() => []);
      this.skipped = this.steps.map(() => false);
      // Ekstra fokus: which concern a product was chosen under (for the summary's label).
      this.concernOf = {};
      this.restore();
      // Answers brought along from a collection (?svar=tor-hud,torhed: "Få hele rutinen" after the test or filters):
      // they go first, so every step opens with what fits them as "Passer til dig".
      const carried = (new URLSearchParams(location.search).get("svar") || "").split(",").filter(Boolean);
      if (carried.length) this.helps = [...carried, ...(this.helps || []).filter((k) => !carried.includes(k))];
      // "Fuldfør din rutine" from a product page (?vaelg=handle): that product is chosen in its step (a core step before
      // Ekstra fokus), as a restored choice is, so the builder opens on the next step.
      const wanted = new URLSearchParams(location.search).get("vaelg");
      if (wanted) {
        const index = this.steps.findIndex((step) => step.querySelector(`[data-build-option][data-handle="${CSS.escape(wanted)}"]:not([data-soldout]):not([data-build-concern-panel] *)`));
        if (index !== -1 && !this.picks[index].length) {
          const option = this.steps[index].querySelector(`[data-build-option][data-handle="${CSS.escape(wanted)}"]`);
          option.hidden = false;
          this.picks[index] = [option.dataset.productId];
          this.skipped[index] = false;
        }
      }

      // A shared routine (?rutine=handle.variant,…, from "Del"): exactly those products and variants, every other step
      // skipped, so the link opens on the finished routine. Komplet, so no step is hidden.
      const shared = (new URLSearchParams(location.search).get("rutine") || "").split(",").filter(Boolean);
      if (shared.length) {
        this.steps.forEach((step, index) => {
          this.picks[index] = [];
          this.skipped[index] = true;
        });
        this.level = "komplet";
        shared.forEach((entry) => {
          const [handle, variant] = entry.split(".");
          const selector = `[data-build-option][data-handle="${CSS.escape(handle)}"]`;
          const index = this.steps.findIndex((step) => step.querySelector(selector));
          if (index === -1) return;
          const option = this.steps[index].querySelector(selector);
          if (option.hasAttribute("data-soldout")) return;
          option.hidden = false;
          if (!this.picks[index].includes(option.dataset.productId)) this.picks[index].push(option.dataset.productId);
          this.skipped[index] = false;
          const select = option.querySelector("select[data-build-variant]");
          if (select && variant && [...select.options].some((o) => o.value === variant)) {
            select.value = variant;
            this.variantChanged(option);
          }
        });
      }
      const shareButton = this.querySelector("[data-build-share]");
      if (shareButton) shareButton.addEventListener("click", () => this.share());
      this.saveButton = this.querySelector("[data-account-save]");
      if (this.saveButton) this.saveButton.addEventListener("click", () => this.saveToAccount(this.saveButton));

      this.steps.forEach((step, index) => {
        step.querySelectorAll("[data-build-option]").forEach((option) => {
          option.querySelector("[data-build-pick]").addEventListener("click", (event) => this.toggle(index, option, event.currentTarget));
          // The whole card chooses (or takes back) the product, as a radio; its links, scent/size and "Læs mere" keep their own.
          option.addEventListener("click", (event) => {
            if (event.target.closest("a, button, select, input, label") || option.classList.contains("is-taken") || option.hasAttribute("data-soldout")) return;
            option.querySelector("[data-build-pick]").click();
          });
          // "Fjern": the chosen product out again (tapping "Valgt" does the same).
          option.querySelector("[data-build-remove]").addEventListener("click", () => {
            this.toggle(index, option, option.querySelector("[data-build-pick]"));
            option.querySelector("[data-build-pick]").focus();
          });
          const variant = option.querySelector("select[data-build-variant]");
          if (variant) variant.addEventListener("change", () => this.variantChanged(option));
        });
        // Ekstra fokus: a concern opens what helps with it; one open at a time, a second tap closes it.
        const chips = [...step.querySelectorAll("[data-build-concern]")];
        chips.forEach((chip) =>
          chip.addEventListener("click", () => {
            const open = chip.getAttribute("aria-pressed") !== "true";
            this.openConcern(step, open ? chip.dataset.buildConcern : null);
          })
        );
        // "Hjælp mig med at vælge": an answer brings its products to the top.
        step.querySelectorAll("[data-build-help-key]").forEach((chip) =>
          chip.addEventListener("click", () => {
            const on = chip.getAttribute("aria-pressed") !== "true";
            // Answers given, newest first, so a later step can reuse the one that fits it.
            const key = chip.dataset.buildHelpKey;
            // One answer per question: another answer here replaces the earlier one (owner, 2026-10-21: clicking through
            // the skin types piled them up, so the all-skin-types products won every time).
            const group = [...step.querySelectorAll("[data-build-help-key]")].map((c) => c.dataset.buildHelpKey);
            this.helps = (this.helps || []).filter((k) => !group.includes(k));
            if (on) this.helps.unshift(key);
            this.applyHelp(step, on ? key : null);
            this.save();
          })
        );
        const more = step.querySelector("[data-build-show-more]");
        if (more)
          more.addEventListener("click", () => {
            step.querySelectorAll("[data-build-more]").forEach((option) => (option.hidden = false));
            more.remove();
          });
        const skip = step.querySelector("[data-build-skip]");
        if (skip)
          skip.addEventListener("click", () => {
            this.picks[index] = [];
            this.skipped[index] = true;
            this.save();
            // The tab and "Din rutine" follow at once (a product chosen here is taken out).
            this.markStep(index);
            this.update();
            this.advance(index);
          });
        const next = step.querySelector("[data-build-next]");
        if (next) next.addEventListener("click", () => this.advance(index));
        const finish = step.querySelector("[data-build-finish]");
        if (finish) finish.addEventListener("click", () => this.show(this.steps.length));
      });
      this.navItems.forEach((item) => item.addEventListener("click", () => this.show(Number(item.dataset.buildGoto))));
      // Enkel / Komplet: Enkel leaves the steps not marked "Med i Enkel" out of the walk, the pills, the total and the
      // overview; their choices wait for Komplet.
      this.levelBox = this.querySelector("[data-build-level]");
      if (this.levelBox) {
        this.levelBox.querySelectorAll("[data-build-level-btn]").forEach((b) =>
          b.addEventListener("click", () => {
            this.setLevel(b.dataset.buildLevelBtn);
            this.save();
          })
        );
        this.setLevel(this.level || "komplet", true);
      }
      this.addBtn.addEventListener("click", () => this.add());
      // The chosen products' stack in the bar opens the overview ("Din rutine").
      this.seeBtn = this.querySelector("[data-build-see]");
      this.seeBtn.addEventListener("click", () => this.show(this.steps.length));

      // The step pills get their background only while pinned under the header: a line just above them is watched
      // passing under the header (no scroll listener; the theme scrolls the body).
      const nav = this.querySelector("[data-build-nav]");
      const sentinel = document.createElement("div");
      sentinel.setAttribute("aria-hidden", "true");
      nav.before(sentinel);
      const watch = () => {
        if (this.navObserver) this.navObserver.disconnect();
        const top = parseFloat(getComputedStyle(nav).top) || 0;
        this.navObserver = new IntersectionObserver(
          ([entry]) => nav.classList.toggle("is-stuck", !entry.isIntersecting && entry.boundingClientRect.top < top + 1),
          { rootMargin: `${-(top + 1)}px 0px 0px 0px` }
        );
        this.navObserver.observe(sentinel);
      };
      watch();
      window.addEventListener("resize", watch, { passive: true });

      this.dialog = this.querySelector("[data-build-peek-dialog]");
      this.querySelectorAll("[data-build-peek]").forEach((link) =>
        link.addEventListener("click", (event) => {
          if (!this.dialog || typeof this.dialog.showModal !== "function") return;
          event.preventDefault();
          this.peek(link.getAttribute("href"));
        })
      );
      window.ec.prefetchWithin(this, "[data-build-peek]", (link) => [link.getAttribute("href"), "product-peek"]);
      if (this.dialog) {
        this.dialog.querySelector("[data-build-peek-close]").addEventListener("click", () => this.dialog.close());
        this.dialog.addEventListener("click", (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }

      this.steps.forEach((step, index) => this.markStep(index));
      // Back on the page with an Ekstra fokus product chosen: its concern is open.
      this.steps.forEach((step) => {
        const picked = step.querySelector("[data-build-concern-panel] .is-picked");
        if (picked) this.openConcern(step, picked.closest("[data-build-concern-panel]").dataset.buildConcernPanel);
      });
      this.show(this.firstOpen(), true);
      this.update();
      // Through the cart drawer, which is set up after this script (layout/theme.liquid): it opens, as for any add.
      if (buy && shared.length) customElements.whenDefined("cart-drawer").then(() => this.buyShared(shared));
      // Back from "Log ind og gem" on this very routine: it saves now, one tap not two (the guide's own save is its own).
      if (this.saveButton && this.saveButton.dataset.loggedIn && shared.length && window.ec.takeSaveAfterLogin) {
        const entries = this.entries();
        const url = entries.length ? this.routineUrl(entries) : null;
        if (url && window.ec.takeSaveAfterLogin("build", url.pathname + url.search)) this.saveToAccount(this.saveButton);
      }
    }

    // The shared routine in the cart, as "Læg rutinen i kurven" (add): what is sold out stays out, and the error line says so.
    buyShared(shared) {
      const soldOut = shared
        .map((entry) => this.querySelector(`[data-build-option][data-handle="${CSS.escape(entry.split(".")[0])}"]`))
        .filter((option) => option && option.hasAttribute("data-soldout"))
        .map((option) => ((option.querySelector("h3, [data-build-name], .build__option-name") || {}).textContent || option.dataset.handle).trim());
      const added = this.distinct().length > 0;
      const done = added ? this.add() : Promise.resolve({ ok: false });
      Promise.resolve(done).then((result) => {
        const error = this.querySelector("[data-build-error]");
        const text = window.ec.soldOutText(this, soldOut, added && (!result || result.ok !== false));
        if (error && text) {
          error.textContent = text;
          error.hidden = false;
        }
      });
    }

    // Order the step's products by the visitor's answers: the answer chosen here counts 10, every other carried answer
    // (Hudtype or Hjælper mod, any step) 4. Ties keep the step's own curated order (page.byg-selv.json), so the owner's
    // order decides; naming many skin types costs nothing (a tie-break on that lifted niche retinol and scrub products).
    // At most two get "Passer til dig"; the rest follow under "Andre muligheder" in the step's own order.
    applyHelp(step, key) {
      const list = step.querySelector(".build__options");
      if (!list) return;
      if (!this.originalOrder) this.originalOrder = new Map();
      if (!this.originalOrder.has(list)) this.originalOrder.set(list, [...list.children].filter((el) => el.matches("[data-build-option]")));
      const chips = [...step.querySelectorAll("[data-build-help-key]")];
      const chip = chips.find((c) => c.dataset.buildHelpKey === key);
      chips.forEach((c) => c.setAttribute("aria-pressed", String(c === chip)));
      list.querySelectorAll("[data-build-others]").forEach((el) => el.remove());
      const options = this.originalOrder.get(list);
      options.forEach((o) => {
        o.querySelector("[data-build-match]").hidden = true;
        o.classList.remove("is-match");
      });
      if (!chip) {
        options.forEach((o) => list.append(o));
        return;
      }
      const wanted = chip.dataset.handles.split(",").filter(Boolean);
      // Answers from other steps' questions count; this question's other answers don't.
      const group = chips.map((c) => c.dataset.buildHelpKey);
      const others = (this.helps || []).filter((k) => k !== key && !group.includes(k));
      // Made for the answer beats made for everyone: a product that names fewer skin types ranks higher (owner, 2026-10-21:
      // "Fedtet", "Kombineret" and "Normal hud" showed the same all-skin-types day creams).
      // A men's product is not the first pick for everyone (it stays under "Andre muligheder").
      const label = chip.textContent.trim();
      const needs = (o) => (o.dataset.hm || "").split("|").filter(Boolean);
      // Pigment or uneven tone among the answers, or an acid or vitamin A product chosen: a day cream with sun protection
      // first (owner, 2026-10-21), as both make the skin more sensitive to sun or need it to show results.
      const chosenHandles = this.chosen().map((x) => (this.option(x.index, x.id) || { dataset: {} }).dataset.handle);
      const sunNeeded =
        [key, ...(this.helps || [])].some((k) => /pigment|hudtone/.test(k)) ||
        chosenHandles.some((h) => /acne-serum|daily-peel|peel-maske|aha-bha|retinol|vitamin-a|pigment/.test(h || ""));
      const score = (o) => {
        const fit = (o.dataset.fit || "").split(" ").filter(Boolean);
        let s = wanted.includes(o.dataset.handle) ? 10 : 0;
        if (sunNeeded && o.hasAttribute("data-spf")) s += 5;
        others.forEach((k) => { if (fit.includes(k)) s += 4; });
        if (o.dataset.koen === "Mand") s -= 2;
        if (fit.includes("alle-hudtyper")) s -= 3;
        return s - fit.length * 0.2;
      };
      // The card's "Hjælper mod" shows two needs: the answer is one of them when the product has it (owner, 2026-10-21:
      // "Tørhed" recommended creams whose card showed only their first two needs, not Tørhed).
      options.forEach((o) => {
        const dd = o.querySelector('[data-fact="hjaelper_mod"]');
        if (!dd) return;
        if (dd.dataset.shown === undefined) dd.dataset.shown = dd.textContent;
        const list = needs(o);
        const at = list.indexOf(label);
        dd.textContent = at > 1 ? [list[0], label].join(" · ") : dd.dataset.shown;
      });
      const rankedRaw = options
        .filter((o) => wanted.includes(o.dataset.handle) && !o.classList.contains("is-taken"))
        .map((o) => ({ o, s: score(o), i: options.indexOf(o) }))
        .sort((x, y) => y.s - x.s || x.i - y.i)
        .slice(0, 2)
        .map((x) => x.o);
      const ranked = rankedRaw;
      const rest = options.filter((o) => !ranked.includes(o));
      // "Passer til dig (2)" over the matching cards, instead of a label and a green line on each.
      if (ranked.length) {
        const head = document.createElement("li");
        head.className = "build__others build__others--matches";
        head.setAttribute("data-build-others", "");
        head.textContent = this.copy.match + " (" + ranked.length + ")";
        list.append(head);
      }
      ranked.forEach((o) => {
        o.hidden = false;
        o.classList.add("is-match");
        list.append(o);
      });
      if (ranked.length && rest.length) {
        const divider = document.createElement("li");
        divider.className = "build__others";
        divider.setAttribute("data-build-others", "");
        divider.textContent = this.copy.others;
        list.append(divider);
      }
      rest.forEach((o) => list.append(o));
    }

    // A step opened with an answer given earlier (same wording, e.g. "Tør hud" in Rens and Dagcreme) applies it.
    carryHelp(step) {
      if (!this.helps || !this.helps.length || step.querySelector('[data-build-help-key][aria-pressed="true"]')) return;
      // Escaped: the answers come from the link (?svar=) and the visit, and a stray quote must not stop the builder.
      const key = this.helps.find((k) => step.querySelector(`[data-build-help-key="${CSS.escape(k)}"]`));
      if (key) this.applyHelp(step, key);
    }

    // Ekstra fokus opens on a concern, so the step shows products at once: the one matching an earlier answer
    // ("Tørhed" or "Tør hud" → Tør hud), else the first. Nothing is chosen for the visitor.
    autoConcern(step) {
      const chips = [...step.querySelectorAll("[data-build-concern]")];
      if (!chips.length || chips.some((c) => c.getAttribute("aria-pressed") === "true")) return;
      const norm = (t) => t.toLowerCase().replace(/æ/g, "ae").replace(/ø/g, "o").replace(/å/g, "a").replace(/\bog\b/g, " ").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
      const alias = { torhed: "tor-hud" };
      const keys = (this.helps || []).map((k) => alias[norm(k)] || norm(k));
      const match = chips.find((c) => {
        const t = norm(c.textContent);
        return keys.some((k) => k === t || t.startsWith(k) || k.startsWith(t));
      });
      this.openConcern(step, (match || chips[0]).dataset.buildConcern);
    }

    openConcern(step, id) {
      step.querySelectorAll("[data-build-concern]").forEach((chip) => chip.setAttribute("aria-pressed", String(chip.dataset.buildConcern === id)));
      // The chosen concern in sight in its sideways row (phone), without moving the page.
      const on = step.querySelector(`[data-build-concern="${id}"]`);
      const row = on && on.parentElement;
      if (row && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, on.offsetLeft - row.offsetLeft - 16);
      step.querySelectorAll("[data-build-concern-panel]").forEach((panel) => (panel.hidden = panel.dataset.buildConcernPanel !== id));
    }

    // A product can sit under two concerns in Ekstra fokus: the card it was chosen from (its variant is the one bought).
    option(index, productId) {
      const cards = [...this.steps[index].querySelectorAll(`[data-build-option][data-product-id="${productId}"]`)];
      const concern = this.concernOf && this.concernOf[productId];
      return (concern && cards.find((card) => card.dataset.concern === concern)) || cards[0] || null;
    }

    // The first step without a choice (and not skipped); all done: the summary.
    // The chosen products as handle.variant, in the order of the steps.
    entries() {
      const entries = [];
      this.picks.forEach((list, index) => {
        if (this.isOff(index)) return;
        list.forEach((id) => {
          const option = this.option(index, id);
          if (!option) return;
          const select = option.querySelector("[data-build-variant]");
          entries.push(option.dataset.handle + (select && select.value ? "." + select.value : ""));
        });
      });
      return entries;
    }
    // This routine's own link: the page with ?rutine=handle.variant,… (opens on the finished routine).
    routineUrl(entries) {
      const url = new URL(location.href);
      ["rutine", "vaelg", "svar", "preview_theme_id", "gemt"].forEach((key) => url.searchParams.delete(key));
      url.searchParams.set("rutine", entries.join(","));
      return url;
    }
    routineTitle() {
      return ((this.querySelector(".build__heading h1") || document.querySelector("h1") || {}).textContent || document.title).trim();
    }
    // "Gem rutine" (ec-shared.js): the routine's link and products, kept in the customer's account. Not named save():
    // that one (below) keeps the choices for the visit, and the later method of the same name replaced this one.
    saveToAccount(button) {
      const entries = this.entries();
      if (!entries.length) return;
      const url = this.routineUrl(entries);
      const here = url.pathname + url.search;
      window.ec.saveRoutine(button, { kind: "build", area: this.dataset.area || "", title: this.routineTitle(), url: here, products: entries }, here);
    }
    // "Del": the page's address with the routine in it (handle.variant per product); the phone's share sheet, else copied.
    share() {
      const entries = this.entries();
      if (!entries.length) return;
      const href = this.routineUrl(entries).href;
      const title = this.routineTitle();
      if (navigator.share) {
        navigator.share({ title, url: href }).catch(() => {});
        return;
      }
      const toast = this.querySelector("[data-build-toast]");
      (navigator.clipboard ? navigator.clipboard.writeText(href) : Promise.reject())
        .then(() => {
          toast.textContent = this.copy.copied;
          toast.hidden = false;
          clearTimeout(this.toastTimer);
          this.toastTimer = setTimeout(() => (toast.hidden = true), 2500);
        })
        .catch(() => window.prompt("", href));
    }
    firstOpen() {
      const open = this.steps.findIndex((step, index) => !this.picks[index].length && !this.skipped[index]);
      return open === -1 ? this.steps.length : open;
    }

    toggle(index, option, button) {
      const id = option.dataset.productId;
      const max = Number(this.steps[index].dataset.max) || 1;
      let list = this.picks[index];
      if (list.includes(id)) {
        list = list.filter((x) => x !== id);
      } else if (max === 1) {
        list = [id];
      } else {
        list = [...list, id];
        // Over the max: the oldest choice gives way.
        if (list.length > max) list = list.slice(list.length - max);
      }
      this.picks[index] = list;
      this.skipped[index] = false;
      // A "Dag & nat" cream chosen as day or night cream is both: it fills the other step too, and leaves both together.
      const other = this.bothSteps(index, id);
      if (other !== -1) {
        this.picks[other] = list.includes(id) ? [id] : this.picks[other].filter((x) => x !== id);
        if (list.includes(id)) this.skipped[other] = false;
        this.markStep(other);
      }
      if (option.dataset.concern) this.concernOf[id] = option.dataset.concern;
      this.save();
      this.markStep(index);
      this.update();
      // A core step is done with one choice: on to the next after a beat, so the tick is seen. The last step (Ekstra
      // fokus) goes on to the overview with its first choice too; its pill brings you back for a second (owner, 2026-10-19).
      const added = list.includes(id);
      if (added && (max === 1 || list.length >= max || index === this.steps.length - 1)) {
        clearTimeout(this.advanceTimer);
        this.advanceTimer = setTimeout(() => this.advance(index), 450);
      }
    }

    // Dagcreme and Natcreme: the first step set to the morning and the first set to the evening (block setting "when").
    pairOf(index) {
      if (!this.pair) {
        const morning = this.steps.findIndex((step) => step.dataset.stepWhen === "morgen");
        const evening = this.steps.findIndex((step) => step.dataset.stepWhen === "aften");
        this.pair = morning > -1 && evening > -1 ? [morning, evening] : [];
      }
      const at = this.pair.indexOf(index);
      return at === -1 ? -1 : this.pair[1 - at];
    }

    // The other step of the pair when this product is a "Dag & nat" cream offered in both; else -1. It is still one
    // product: counted, priced and added once (distinct()).
    // Not in Komplet: there the night step is for a real night cream, else "Komplet · 5 trin" bought 4 products (owner,
    // 2026-10-21); the cream shows as taken in the other step.
    bothSteps(index, id) {
      if (this.level === "komplet") return -1;
      const other = this.pairOf(index);
      if (other === -1) return -1;
      const here = this.option(index, id);
      return here && here.hasAttribute("data-day-night") && this.option(other, id) ? other : -1;
    }

    advance(index) {
      const rest = this.steps.findIndex((step, i) => i > index && !this.isOff(i) && !this.picks[i].length && !this.skipped[i]);
      this.show(rest === -1 ? this.steps.length : rest);
    }

    show(index, initial) {
      this.current = index;
      if (this.steps[index]) this.carryHelp(this.steps[index]);
      if (this.steps[index]) this.autoConcern(this.steps[index]);
      this.steps.forEach((step, i) => (step.hidden = i !== index));
      this.done.hidden = index !== this.steps.length;
      // The overview is the routine only: no page head or guide box above the pills (owner, 2026-10-20).
      this.classList.toggle("is-done", index === this.steps.length);
      this.barNav();
      this.navItems.forEach((item, i) => {
        if (i === index) item.setAttribute("aria-current", "step");
        else item.removeAttribute("aria-current");
      });
      // The marked pill in sight in its row (sideways only; the row is pinned).
      const pill = this.navItems[index];
      if (pill) {
        const bar = pill.closest("[data-build-nav]");
        const left = pill.parentElement.offsetLeft - 16;
        if (left < bar.scrollLeft || pill.parentElement.offsetLeft + pill.offsetWidth > bar.scrollLeft + bar.clientWidth) {
          bar.scrollTo({ left, behavior: initial ? "auto" : "smooth" });
        }
      }
      if (index === this.steps.length) this.renderDone();
      this.warmPeeks(this.steps[index]);
      if (initial) return;
      const target = index === this.steps.length ? this.done : this.steps[index];
      // The step (or the overview) from its top, just under the pinned step pills; the pills stay pinned, so their
      // own position can't tell (owner, 2026-10-19: "Se rutine" opened in the middle of the overview).
      // scrollIntoView, as the theme scrolls the body rather than the window.
      const navBottom = this.querySelector("[data-build-nav]").getBoundingClientRect().bottom;
      if (Math.abs(target.getBoundingClientRect().top - navBottom) > 24) {
        target.style.scrollMarginTop = navBottom + 12 + "px";
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      const heading = target.querySelector("h2");
      if (heading) {
        heading.setAttribute("tabindex", "-1");
        heading.focus({ preventScroll: true });
      }
    }

    markStep(index) {
      const list = this.picks[index];
      const single = (Number(this.steps[index].dataset.max) || 1) === 1;
      this.steps[index].querySelectorAll("[data-build-option]").forEach((option) => {
        if (option.hasAttribute("data-soldout")) return;
        const on = list.includes(option.dataset.productId);
        option.classList.toggle("is-picked", on);
        // A chosen product behind "Vis flere" stays in sight.
        if (on) option.hidden = false;
        const pick = option.querySelector("[data-build-pick]");
        pick.setAttribute("aria-pressed", String(on));
        // A step that takes one product: the others say they replace it.
        pick.querySelector("[data-build-pick-label]").textContent = on
          ? this.copy.picked
          : single && list.length
            ? this.copy.pick_instead
            : this.copy.pick;
        pick.querySelector("use").setAttribute("href", on ? "#icon-checkmark" : "#icon-plus");
        option.querySelector("[data-build-remove]").hidden = !on;
      });
      // A concern with a chosen product gets a tick.
      this.steps[index].querySelectorAll("[data-build-concern]").forEach((chip) => {
        const panel = this.steps[index].querySelector(`[data-build-concern-panel="${chip.dataset.buildConcern}"]`);
        // Only the concern it was chosen under, when the same product helps with two.
        const picked = panel ? [...panel.querySelectorAll(".is-picked")] : [];
        chip.classList.toggle(
          "has-pick",
          picked.some((o) => !this.concernOf[o.dataset.productId] || this.concernOf[o.dataset.productId] === o.dataset.concern)
        );
      });
      const item = this.navItems[index];
      const label = item.querySelector("[data-build-nav-pick]");
      if (!label.dataset.initial) label.dataset.initial = label.textContent;
      const names = list.map((id) => this.item(index, id)).filter(Boolean).map((x) => x.name);
      label.textContent = names.length ? names.join(", ") : this.skipped[index] ? this.copy.skipped : label.dataset.initial;
      item.classList.toggle("is-done", names.length > 0);
      item.classList.toggle("is-skipped", !names.length && this.skipped[index]);
    }

    // What a chosen product is right now: its variant, price and picture as the card shows them.
    item(index, id) {
      const option = this.option(index, id);
      if (!option) return null;
      const variant = option.querySelector("[data-build-variant]");
      const selected = variant.tagName === "SELECT" ? variant.selectedOptions[0] : variant;
      const image = option.querySelector("[data-build-image]");
      // The chosen variant, or the size of a product without a choice ("80 g"), for the overview's line.
      const variantTitle = variant.tagName === "SELECT" ? selected.textContent.trim() : ((option.querySelector(".build__option-size") || {}).textContent || "").trim();
      return {
        index,
        id,
        name: option.querySelector(".build__option-name").textContent.trim(),
        variantId: Number(variant.value),
        variantTitle,
        price: Number(selected.dataset.price) || 0,
        image: image ? image.currentSrc || image.src : "",
        // Enkel has no night cream: the morning cream goes on in the evening too, SPF or not (owner, 2026-10-21/22).
        when: this.level === "enkel" && this.levelBox && option.dataset.when === "morgen" ? "begge" : option.dataset.when || "begge",
        type: option.dataset.type || "",
        // Counts for the Custom-Routine discount: the sync lists every product with a "Til dig, der …" line.
        listed: option.hasAttribute("data-listed"),
        concern: this.concernOf[id] || option.dataset.concern || "",
        derm: option.dataset.derm === "true",
        // "ff": AllergyCertified covers only the fragrance-free variant, so only while that one is chosen.
        allergy: option.dataset.allergy === "true" || (option.dataset.allergy === "ff" && selected.dataset.ff === "true"),
      };
    }

    chosen() {
      return this.picks.flatMap((list, index) => (this.isOff(index) ? [] : list.map((id) => this.item(index, id)).filter(Boolean)));
    }

    // A step left out by "Enkel".
    isOff(index) {
      return this.level === "enkel" && Boolean(this.levelBox) && !this.steps[index].hasAttribute("data-simple");
    }

    setLevel(level, initial) {
      this.level = level === "enkel" ? "enkel" : "komplet";
      this.levelBox.querySelectorAll("[data-build-level-btn]").forEach((b) => b.setAttribute("aria-pressed", String(b.dataset.buildLevelBtn === this.level)));
      const titles = (on) =>
        this.steps.filter((step, i) => step.hasAttribute("data-simple") === on).map((step) => step.querySelector(".build__step-title").textContent.trim().toLowerCase());
      const join = (list) => (list.length > 1 ? list.slice(0, -1).join(", ") + this.copy.list_and + list[list.length - 1] : list[0] || "");
      const line = (list, text) => {
        const named = join(list);
        return (named.charAt(0).toUpperCase() + named.slice(1)) + ". " + text;
      };
      this.levelBox.querySelector("[data-build-level-text]").textContent =
        this.level === "enkel" ? line(titles(true), this.copy.level_simple_text) : line(this.steps.map((s) => s.querySelector(".build__step-title").textContent.trim().toLowerCase()), this.copy.level_full_text);
      this.navItems.forEach((item, i) => (item.closest("li").hidden = this.isOff(i)));
      // "Trin 2" over a step's title counts the steps this level walks, as the numbered tabs do.
      let n = 0;
      this.steps.forEach((step, i) => {
        if (this.isOff(i)) return;
        n += 1;
        const num = step.querySelector("[data-build-step-num]");
        if (num) num.textContent = this.copy.step.replace("[n]", n);
      });
      if (initial) return;
      // On a step Enkel leaves out: on to the next one it keeps (or the overview).
      if (this.current < this.steps.length && this.isOff(this.current)) this.advance(this.current);
      this.update();
    }

    // One per product: the routine discount counts different products, so a product chosen in two steps counts, costs
    // and goes in the cart once.
    distinct() {
      const seen = new Set();
      return this.chosen().filter((x) => !seen.has(x.id) && seen.add(x.id));
    }

    // The Custom-Routine discount exactly as checkout gives it (routine-fn with routine byg-selv, config from
    // .ecooking-tools/routine-discount-sync.mjs): the products listed there (data-listed) count, one unit each, from
    // this.min (3) different ones. Owner, 2026-10-23: never show a saving checkout won't give.
    deal(items) {
      const counted = items.filter((x) => x.listed);
      const on = this.percent > 0 && counted.length >= this.min;
      const total = items.reduce((sum, x) => sum + x.price, 0);
      const saving = on ? counted.reduce((sum, x) => sum + Math.round((x.price * this.percent) / 100), 0) : 0;
      return { on, left: this.min - counted.length, total, saving, toPay: total - saving };
    }

    // "I alt:" with the price before the discount struck through and the price to pay, only when the discount applies
    // (owner, 2026-10-23: no "Du sparer" line).
    showTotal(box, deal) {
      const before = box.querySelector("[data-build-before]");
      before.hidden = !deal.on;
      before.textContent = deal.on ? this.money(deal.total) : "";
      box.querySelector("[data-build-total]").textContent = this.money(deal.toPay);
    }

    variantChanged(option) {
      const variant = option.querySelector("select[data-build-variant]");
      const selected = variant.selectedOptions[0];
      option.querySelector("[data-build-price]").textContent = this.money(Number(selected.dataset.price) || 0);
      // A sale price: the old price struck through above it.
      const compare = option.querySelector("[data-build-card-compare]");
      if (compare) {
        const before = Number(selected.dataset.compare) || 0;
        compare.hidden = !before;
        if (before) compare.textContent = this.money(before);
      }
      const image = option.querySelector("[data-build-image]");
      if (image && selected.dataset.image) {
        image.removeAttribute("srcset");
        image.src = selected.dataset.image;
      }
      if (!this.restoring) this.save();
      this.update();
    }

    // Before the first choice the bar is only "Vælg dit første produkt"; on the overview the stack has nowhere to go.
    barNav() {
      if (!this.seeBtn) return;
      const count = this.distinct().length;
      this.seeBtn.disabled = this.current === this.steps.length;
      const hint = this.querySelector("[data-build-hint]");
      if (hint) {
        hint.hidden = count > 0;
        hint.textContent = this.copy.bar_empty;
      }
    }

    // A product chosen in one step can't be chosen in another (owner, 2026-10-20: Acne Serum in Serum and Ekstra fokus,
    // one cream as day and night cream): its card elsewhere is greyed out and says where it is.
    markTaken() {
      // A pick saved twice before this rule (another visit) stays in its first step only.
      const owner = new Map();
      let fixed = false;
      this.picks.forEach((list, i) => {
        this.picks[i] = list.filter((id) => {
          if (owner.has(id) && this.bothSteps(owner.get(id), id) !== i) { fixed = true; return false; }
          if (!owner.has(id)) owner.set(id, i);
          return true;
        });
      });
      if (fixed) this.save();
      // Labels back to "Vælg"/"Valgt" first, then the taken ones get theirs.
      this.steps.forEach((_, i) => this.markStep(i));
      this.steps.forEach((step, i) =>
        step.querySelectorAll("[data-build-option]").forEach((o) => {
          if (o.hasAttribute("data-soldout")) return;
          const at = owner.get(o.dataset.productId);
          const taken = at !== undefined && at !== i && this.bothSteps(at, o.dataset.productId) !== i;
          o.classList.toggle("is-taken", taken);
          const pick = o.querySelector("[data-build-pick]");
          pick.disabled = taken;
          if (taken) {
            const title = this.navItems[at]?.querySelector(".build__nav-label")?.textContent.trim() || "";
            pick.querySelector("[data-build-pick-label]").textContent = this.copy.taken.replace("[step]", title);
            pick.querySelector("use").setAttribute("href", "#icon-checkmark");
          }
        })
      );
    }

    update() {
      this.markTaken();
      const items = this.distinct();
      const count = items.length;
      this.barNav();
      const offer = this.deal(items);
      const deal = offer.on;
      const copy = this.copy;

      // The stack: the first three chosen packshots, then "+2" for the rest.
      const stack = this.querySelector("[data-build-stack]");
      stack.replaceChildren(
        ...items.slice(0, 3).map((x) => {
          const span = document.createElement("span");
          span.className = "build__stack-image";
          if (x.image) span.style.backgroundImage = `url("${x.image}")`;
          return span;
        }),
        ...(items.length > 3 ? [Object.assign(document.createElement("span"), { className: "build__stack-more", textContent: "+" + (items.length - 3) })] : [])
      );
      this.querySelector("[data-build-count]").textContent = count ? "· " + copy.bar_count.replace("[count]", count) : "";
      const status = this.querySelector("[data-build-status]");
      // Under the total only "Vælg dit første produkt" before a choice, or the hint when one more product would unlock
      // the discount; the discount itself is the struck price beside the total.
      status.textContent = !count ? copy.bar_empty : !deal && offer.left === 1 && this.percent > 0 ? copy.bar_need_one : "";
      status.hidden = !status.textContent;

      const totalBox = this.querySelector("[data-build-total-box]");
      totalBox.hidden = !count;
      this.showTotal(totalBox, offer);
      const toPay = offer.toPay;
      // Toward free delivery, from what the routine costs after its discount (ec-shared.js); what is reached (free
      // delivery, the gift by name) is a line in "Din rutine" (renderDone), not in the bar.
      const nudge = this.querySelector("[data-build-nudge]");
      // Under the total one line: the hint toward the discount when there is one, else the way to free delivery.
      if (nudge && window.ec) window.ec.nudge(count && !status.textContent ? toPay : 0, nudge, { shipping: copy.nudge_shipping, done: false });

      this.addBtn.disabled = !count || this.adding;
      // The button's words say the state, as the PDP routine's: "Læg rutinen i kurven (5 varer)", "Lægger i kurven …",
      // "Lagt i kurven".
      const btn = this.addBtn.dataset;
      this.addBtn.querySelector("[data-build-add-label]").textContent = this.adding ? copy.adding : this.added ? copy.added : count === 1 ? btn.labelOne : btn.labelMany.replace("[count]", count || 0);
      this.addBtn.setAttribute("aria-busy", this.adding ? "true" : "false");
      this.classList.toggle("has-picks", count > 0);
      if (this.current === this.steps.length) this.renderDone();
    }

    // The routine as it is used: Morgen and Aften (from the products' "Tidspunkt"), in step order; what it gives you;
    // and a skipped core step offered again.
    renderDone() {
      const copy = this.copy;
      const items = this.chosen();
      const unique = this.distinct();
      const offer = this.deal(unique);
      const titleOf = (index) => this.steps[index].querySelector(".build__step-title").textContent.trim();

      // "Din rutine er klar" only with every core step filled; else "Din rutine" and what is missing.
      // Steps Enkel leaves out aren't missing.
      const missing = this.steps.filter((step, index) => !step.hasAttribute("data-optional") && !this.isOff(index) && !this.picks[index].length).map((step) => step.querySelector(".build__step-title").textContent.trim());
      this.querySelector("[data-build-done-title]").textContent = missing.length ? copy.done_title_partial : copy.done_title;
      const doneText = this.querySelector("[data-build-done-text]");
      if (!doneText.dataset.text) doneText.dataset.text = doneText.textContent;
      doneText.textContent = missing.length ? copy.done_missing.replace("[steps]", missing.join(", ")) : doneText.dataset.text;

      this.querySelector("[data-build-done-meta]").textContent = copy.done_count.replace("[count]", unique.length);
      // "I alt:", as in the bar.
      const doneTotal = this.querySelector("[data-build-done-total]");
      doneTotal.hidden = !unique.length;
      this.showTotal(doneTotal, offer);

      // In the order they go on the skin: cleanse, toner or exfoliating tonic, serum, cream, oil, mask, so a serum from
      // Ekstra pleje sits with the other serum, not after the creams. Two serums for both times: the routine's own stays
      // morning and evening, the second is for the evening (owner, 2026-10-21: "2 serums both morning and night?").
      const layer = (x) => [/rens/i, /tonic|essens|mist|spray|eksfol|peel/i, /serum/i, /creme|lotion|balm/i, /olie/i, /maske/i].findIndex((re) => re.test(x.type));
      // Body and hair (data-area): the steps' own order, and no morning/evening (owner, 2026-10-22: builders for both).
      const face = (this.dataset.area || "ansigt") === "ansigt";
      const list = face
        ? unique.map((x, i) => ({ x, i, l: layer(x) === -1 ? 3 : layer(x) })).sort((a, b) => a.l - b.l || a.i - b.i).map((a) => a.x)
        : unique.map((x, i) => ({ x, i })).sort((a, b) => a.x.index - b.x.index || a.i - b.i).map((a) => a.x);
      const serums = list.filter((x) => /serum/i.test(x.type) && x.when === "begge");
      const whenOf = (x) => (serums.length > 1 && serums.indexOf(x) > 0 ? "aften" : x.when);
      const sun = '<svg aria-hidden="true" viewBox="0 0 20 20" width="12" height="12"><circle cx="10" cy="10" r="3.6" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.7 4.7l1.4 1.4M13.9 13.9l1.4 1.4M4.7 15.3l1.4-1.4M13.9 6.1l1.4-1.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
      const moon = '<svg aria-hidden="true" viewBox="0 0 20 20" width="12" height="12"><path d="M15.5 12.6A6.5 6.5 0 0 1 7.4 4.5a6.5 6.5 0 1 0 8.1 8.1z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
      // As Find din rutine's result rows (routine-builder.js renderSummary): step, name (opens the product in the panel),
      // variant with "Skift" (back to its step, where product and variant are chosen), time of day, price.
      const row = (x, n) => {
        const li = document.createElement("li");
        li.innerHTML =
          '<div class="routine__row build__row"><span class="routine__row-img"></span><span class="routine__row-text">' +
          '<span class="routine__row-label"></span><span class="routine__row-name"><button type="button" class="routine__row-open"></button></span>' +
          '<span class="routine__row-variant"></span><span class="routine-step__when routine__row-when"></span><span class="routine__row-price"></span></span>' +
          '<svg class="routine__row-chevron" viewBox="0 0 20 20" aria-hidden="true"><use href="#icon-chevron"></use></svg></div>';
        if (x.image) {
          const img = document.createElement("img");
          img.src = x.image;
          img.alt = "";
          li.querySelector(".routine__row-img").append(img);
        }
        li.querySelector(".routine__row-label").textContent = copy.step.replace("[n]", n) + " · " + titleOf(x.index) + (x.concern ? " · " + x.concern : "");
        const open = li.querySelector(".routine__row-open");
        open.textContent = x.name;
        open.addEventListener("click", () => {
          if (this.dialog && typeof this.dialog.showModal === "function") this.peekChosen(x);
          else this.show(x.index);
        });
        const variant = li.querySelector(".routine__row-variant");
        if (x.variantTitle) variant.append(x.variantTitle.replace(/ \/ /g, " · "), " ");
        const swap = document.createElement("button");
        swap.type = "button";
        swap.className = "routine__row-change routine-step__change";
        swap.textContent = copy.change;
        swap.setAttribute("aria-label", copy.change + ": " + x.name);
        swap.addEventListener("click", () => this.show(x.index));
        variant.append(swap);
        const when = whenOf(x);
        if (face)
          li.querySelector(".routine__row-when").innerHTML =
            when === "morgen" ? sun + copy.morning : when === "aften" ? moon + copy.evening : sun + moon + copy.both_times;
        else li.querySelector(".routine__row-when").remove();
        li.querySelector(".routine__row-price").textContent = this.money(x.price);
        return li;
      };
      this.querySelector("[data-build-list]").replaceChildren(...list.map((x, i) => row(x, i + 1)));
      const morning = list.filter((x) => whenOf(x) !== "aften").length;
      const evening = list.filter((x) => whenOf(x) !== "morgen").length;

      // Reassurance only where every chosen product carries it; the guarantee always (its popup); the ritual.
      const tick = () => {
        const span = document.createElement("span");
        span.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><use href="#icon-checkmark"></use></svg>';
        return span.firstChild;
      };
      const line = (...parts) => {
        const li = document.createElement("li");
        li.append(tick(), ...parts);
        return li;
      };
      const safe = document.createElement("span");
      const facts = [];
      if (items.length && items.every((x) => x.derm)) facts.push(copy.promise_derm);
      if (items.length && items.every((x) => x.allergy)) facts.push(copy.promise_allergy);
      if (facts.length) safe.append(facts.join(" · ") + " · ");
      const holder = document.createElement("span");
      holder.innerHTML = '<drawer-control for="satisfaction-guarantee" action="open" role="button" tabindex="0" class="guide__promise-link"></drawer-control>';
      holder.firstChild.textContent = copy.promise_guarantee;
      safe.append(holder.firstChild);
      const ritual = !face ? "" : morning && evening ? copy.ritual_both : morning ? copy.ritual_morning : evening ? copy.ritual_evening : "";
      // Free delivery and the gift, by name, once the routine reaches them (with what is in the cart already).
      const toPay = offer.toPay;
      const perk = window.ec ? window.ec.perk(toPay, { both: copy.nudge_both, gift_done: copy.nudge_gift_done, shipping_done: copy.nudge_shipping_done }) : "";
      const promise = this.querySelector("[data-build-promise]");
      promise.replaceChildren(...(items.length ? [...(perk ? [line(perk)] : []), line(safe), ...(ritual ? [line(ritual)] : [])] : []));
      promise.hidden = !items.length;
      const rail = this.querySelector("[data-build-promise-rail]");
      if (rail) {
        rail.replaceChildren(...[...promise.children].map((li) => li.cloneNode(true)));
        rail.hidden = !items.length;
      }

      // A core step left out: said plainly, with a way back to it.
      const skipped = this.querySelector("[data-build-skipped]");
      const notes = this.steps
        .map((step, index) => ({ step, index }))
        .filter(({ step, index }) => !step.hasAttribute("data-optional") && !this.isOff(index) && !this.picks[index].length)
        .map(({ index }) => {
          const p = document.createElement("p");
          p.className = "build__skipped-note";
          p.append(copy.skipped_note.replace("[step]", titleOf(index)) + " ");
          const button = document.createElement("button");
          button.type = "button";
          button.className = "build__skipped-add txt-btn-underscore-1";
          button.textContent = copy.add_step.replace("[step]", titleOf(index));
          button.addEventListener("click", () => this.show(index));
          p.append(button);
          return p;
        });
      skipped.replaceChildren(...notes);
      skipped.hidden = !notes.length;
    }

    add() {
      const items = this.distinct().map((x) => ({
        id: x.variantId,
        quantity: 1,
        properties: {
          _atc_source: "byg-selv",
          _routine: this.dataset.routine,
        },
      }));
      if (!items.length || this.adding) return Promise.resolve({ ok: false });
      const cart = document.querySelector("cart-drawer");
      const error = this.querySelector("[data-build-error]");
      error.hidden = true;
      this.adding = true;
      this.update();
      const request =
        cart && typeof cart.postAdd === "function"
          ? cart.postAdd({ items, sections: cart.sectionsToRefresh })
          : fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ items }),
            }).then((r) => ({ ok: r.ok }));
      return request
        .then((result) => {
          if (result.ok) {
            this.added = true;
            setTimeout(() => {
              this.added = false;
              this.update();
            }, 2500);
          } else {
            error.textContent = result.message || this.copy.error;
            error.hidden = false;
          }
          return result;
        })
        .catch(() => {
          error.textContent = this.copy.error;
          error.hidden = false;
          return { ok: false };
        })
        .finally(() => {
          this.adding = false;
          this.update();
        });
    }

    // The panel on one of the chosen products; its head lists them all (packshots) to switch, the shown one marked.
    // The drawer opens at its top, packshot first: for a moment it is held there (the gallery and Safari's focus moved
    // it down, the packshot cut off under the head; owner's iPhone, 2026-10-21), until the customer touches or scrolls it.
    pinTop(panel) {
      let touched = false;
      const stop = () => (touched = true);
      panel.addEventListener("touchstart", stop, { once: true, passive: true });
      panel.addEventListener("wheel", stop, { once: true, passive: true });
      const until = Date.now() + 1000;
      const hold = () => {
        if (touched || !panel.open) return;
        panel.scrollTop = 0;
        if (Date.now() < until) requestAnimationFrame(hold);
      };
      hold();
    }

    peekChosen(item) {
      const thumbs = this.dialog.querySelector("[data-build-peek-thumbs]");
      const items = this.distinct();
      thumbs.replaceChildren(
        ...items.map((x) => {
          const b = document.createElement("button");
          b.type = "button";
          b.className = "routine__stepper-thumb";
          b.setAttribute("aria-label", x.name);
          if (x.id === item.id && x.index === item.index) b.setAttribute("aria-current", "step");
          if (x.image) {
            const img = document.createElement("img");
            img.src = x.image;
            img.alt = "";
            b.append(img);
          }
          b.addEventListener("click", () => this.peekChosen(x));
          return b;
        })
      );
      thumbs.hidden = false;
      const link = this.option(item.index, item.id)?.querySelector("[data-build-peek]");
      this.peek(link ? link.getAttribute("href") : "", true);
    }

    // "Læs mere" ready before the tap: once the page is idle, the drawer text of the step's shown products is fetched
    // (small HTML, no pictures; ec.sectionFetch keeps it for the visit). Touching a link alone started it too late on a
    // phone (owner, 2026-10-20). Not on Data Saver or a 2G connection.
    warmPeeks(step) {
      if (!step || !window.ec) return;
      const net = navigator.connection;
      if (net && (net.saveData || /2g/.test(net.effectiveType || ""))) return;
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 600));
      idle(() =>
        step.querySelectorAll("[data-build-option]:not([hidden]) [data-build-peek]").forEach((link) =>
          window.ec.sectionFetch(link.getAttribute("href"), "product-peek").catch(() => {})
        )
      );
    }

    peek(href, keepThumbs) {
      if (!keepThumbs) {
        const thumbs = this.dialog.querySelector("[data-build-peek-thumbs]");
        if (thumbs) thumbs.hidden = true;
      }
      const body = this.dialog.querySelector("[data-build-peek-body]");
      // Only the latest request may fill the panel (a quick switch between products: the slower answer is dropped).
      const ticket = (this.peekTicket = (this.peekTicket || 0) + 1);
      const current = () => ticket === this.peekTicket && this.dialog.open;
      body.replaceChildren();
      this.dialog.querySelector("[data-build-peek-title]").textContent = "";
      // Already open when another packshot in its head is tapped: showModal() on an open dialog throws in older Safari.
      if (!this.dialog.open) this.dialog.showModal();
      this.dialog.scrollTop = 0;
      this.dialog.classList.add("is-loading");
      window.ec
        .sectionFetch(href, "product-peek")
        .then((html) => {
          if (!current()) return;
          const section = new DOMParser().parseFromString(html, "text/html").querySelector(".shopify-section");
          if (!section) throw new Error("no product");
          body.replaceChildren(...section.childNodes);
          // The product's name in the sticky head, so it stays in sight while scrolling.
          const name = body.querySelector("[data-peek-title]");
          this.dialog.querySelector("[data-build-peek-title]").textContent = name ? name.textContent.trim() : "";
          body.focus({ preventScroll: true });
        this.pinTop(this.dialog);
        })
        .catch(() => {
          // No details to show: the product page instead.
          if (current()) window.location.href = href;
        })
        .finally(() => {
          if (ticket === this.peekTicket) this.dialog.classList.remove("is-loading");
        });
    }

    // The visitor's choices on this page, kept for the visit (a product page and back keeps them).
    save() {
      const variants = {};
      this.picks.forEach((list, index) =>
        list.forEach((id) => {
          const option = this.option(index, id);
          if (option) variants[id] = option.querySelector("[data-build-variant]").value;
        })
      );
      try {
        sessionStorage.setItem(this.storeKey, JSON.stringify({ picks: this.picks, skipped: this.skipped, variants, helps: this.helps || [], level: this.level }));
      } catch (e) {}
    }

    restore() {
      let data = null;
      try {
        data = JSON.parse(sessionStorage.getItem(this.storeKey) || "null");
      } catch (e) {}
      if (!data || !Array.isArray(data.picks)) return;
      this.helps = Array.isArray(data.helps) ? data.helps : [];
      if (data.level) this.level = data.level;
      this.restoring = true;
      this.steps.forEach((step, index) => {
        // Only products still on the page (in stock, still in the step).
        this.picks[index] = (data.picks[index] || []).filter((id) => this.option(index, id) && !this.option(index, id).hasAttribute("data-soldout"));
        this.skipped[index] = Boolean(data.skipped && data.skipped[index]) && !this.picks[index].length;
        this.picks[index].forEach((id) => {
          const select = this.option(index, id).querySelector("select[data-build-variant]");
          const wanted = data.variants && data.variants[id];
          if (select && wanted && [...select.options].some((o) => o.value === wanted)) {
            select.value = wanted;
            this.variantChanged(this.option(index, id));
          }
        });
      });
      this.restoring = false;
    }

    // Prices are already in the visitor's currency; ec-shared.js prints them as Liquid's `money` does.
    money(cents) {
      return window.ec.money(cents);
    }
  }

  customElements.define("routine-build", RoutineBuild);
}
